export default class LicenseConsumption {
  constructor(API) {
    this.api = API;
  }
  async getLicenseConsumption(licenseID, consumptionID) {
    const req = await this.api.newBaseRequest("GET");
    req.path = "/license/" + licenseID + "/consumption/" + consumptionID;
    return await req.exec();
  }
  async updateLicenseConsumption(consumptionID, body) {
    const req = await this.api.newBaseRequest("PUT");
    req.body = { ...body };
    req.path = "/license/consumption/" + consumptionID;
    return await req.exec();
  }
  async getLicenseConsumptions(consumptionIDs) {
    const req = await this.api.newBaseRequest("POST");
    req.body = { IDs: consumptionIDs };
    req.path = "/licenses/consumptions";
    return await req.exec();
  }
  async getLicenseConsumptionsByLicenseID(licensesID) {
    const req = await this.api.newBaseRequest("POST");
    req.body = { IDs: licensesID };
    req.path = "/licenses/consumptions/licensesID";
    return await req.exec();
  }
  async searchLicenseConsumption(externalID, from, to) {
    const req = await this.api.newBaseRequest("POST");
    req.body = { externalID, from, to };
    req.path = "/licenses/consumption/search";
    return await req.exec();
  }
}
